export const HOME_SECTIONS = {
  projectsSub: 'Projects',
  projectsTitle: 'Latest completed projects',
  projectsLoading: 'Loading projects...',
  projectsEmpty: 'No projects published yet. Add projects in the admin panel.',
  projectsLoadError: 'Unable to load projects. Please check that the backend API is reachable.',
  blogSub: 'News & Blog',
  blogTitleLine1: 'Our latest news post',
  blogTitleLine2: 'and articles?',
  blogLoading: 'Loading latest posts...',
  blogEmpty: 'No blog posts published yet. Add posts in the admin panel.',
  blogLoadError: 'Unable to load blog posts. Please check that the backend API is reachable.',
  readMore: 'Read More',
  testimonialsSub: 'Testimonials',
  testimonialsTitle: 'Our clients reviews.',
  reviewsLoading: 'Loading reviews...',
  reviewsEmpty: 'No client reviews published yet. Add reviews in the admin panel.',
  teamSub: 'Team Members',
  teamTitle: 'Expert team members.',
  teamLoading: 'Loading team...',
  teamEmpty: 'No team members published yet. Add team members in the admin panel.',
  teamLoadError: 'Unable to load team. Please check that the backend API is reachable.',
  teamSwipeHint: 'Swipe or use arrows to see more team members',
  servicesLoading: 'Loading services...',
  servicesEmpty: 'No services published yet. Add services in the admin panel.',
  servicesLoadError: 'Unable to load services. Please check that the backend API is reachable.',
};
